import {createContext, useContext, useEffect, useState, ReactNode} from 'react';

const IsMobileContext = createContext(false);

const MOBILE_BREAKPOINT = 768;

const IsMobileProvider = ({children}: {children: ReactNode}) => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <IsMobileContext.Provider value={isMobile}>
      {children}
    </IsMobileContext.Provider>
  );
};

const useIsMobile = () => useContext(IsMobileContext);

export {IsMobileProvider, useIsMobile};
